import React, { useEffect, useState } from 'react'
import { useRequest } from '../../hooks/UseRequest'
import { setNotification } from "../../redux/notificationSlice"
import { SYSTEM_MODULES } from '../../constants'
import { selectAuth } from "../../redux/authSlice"
import { setModal, selectModal } from "../../redux/modalSlice"
import { fetchModules } from '../../redux/moduleSlice'
import { fetchModuleData } from '../../redux/moduleDataSlice'
import { useDispatch, useSelector } from 'react-redux'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from "react-router-dom"
import { triggerRerender } from "../../redux/rerenderSlice";

export default function DeleteRecordModal() {
  const dispatch = useDispatch()
  const requests = useRequest()
  const auth = useSelector(selectAuth)
  const modal = useSelector(selectModal)
  const [deleting, setDeleting] = useState(false)
  const navi = useNavigate()

  const deleteRecord = async () => {
    try {
      if (modal?.options?.isMappingTable) {
        requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/${modal.options.link}`)
      } else {
        requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/${modal.options.baseName}/${modal.options.id}${modal.options.currentDate ? "?current_date=" + modal.options.currentDate : ""}`)
      }
      setDeleting(true)
      const resp = await requests.delete()
      if (resp.status === 204) {
        if (/loan\/(\d+)\/payment/.test(modal.options.baseName)) {
          // The `triggerRerender` function is used to rerender only a specific subpanel.
          dispatch(triggerRerender({ subpanelId: 'payment_schedule' }));
        } else {
          // The `triggerRerender` function is used to rerender only a specific subpanel.
          dispatch(triggerRerender({ subpanelId: modal.options?.subBaseName }));

          if (!modal?.options?.isMappingTable && !modal?.options?.subBaseName) {
            if (SYSTEM_MODULES.includes(modal.options.baseName)) {
              await dispatch(fetchModules(auth.accessToken))
            } else {
              await dispatch(
                fetchModuleData({
                  accessToken: auth.accessToken,
                  module_endpoint: modal.options.baseName,
                })
              )
            }
          }
        }
        dispatch(setNotification({ type: 'success', body: 'Record deleted successfully' }))
        dispatch(setModal({ is_active: false }))
        setDeleting(false)
        //Call On success
        if (modal?.options?.onSuccess) {
          modal?.options?.onSuccess()
        }
        // this portion is used for redirect to the list page when deleting from module detail page
        if (modal?.options?.navTo) {
          navi(modal.options.navTo)
        }
      } else {
        dispatch(setNotification({ type: 'error', body: 'Oops! Something went wrong' }))
        dispatch(setModal({ is_active: false }))
        setDeleting(false)
      }
    } catch (error) {
      dispatch(setNotification({ type: 'error', body: error.response?.data?.message }))
      dispatch(setModal({ is_active: false }))
      setDeleting(false)
    }
  }

  const confirmText = modal?.options?.confirmText ? modal?.options?.confirmText : `Are you sure want to delete this record with ID ${modal?.options?.id} ?`;

  return modal.is_active && modal.type === 'delete_record' ? (
    <div className="modal is-active" data-testid="delete-record-modal">
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="box">
          <h3 className="title has-text-danger is-size-4">Delete Confirmation</h3>
          <p className="has-text-dark my-5">{confirmText}</p>
          <div className="field is-grouped is-flex is-justify-content-flex-end">
            <div className="buttons">
              {deleting && (
                <span className="has-text-danger"><FontAwesomeIcon icon={faSpinner} className="fa-pulse px-2" /> Please wait. Deleting...</span>
              )}
              {!deleting && (
                <>
                  <button data-testid="delete-record-modal-cancel" className="button is-light" onClick={() => dispatch(setModal({ is_active: false }))}>
                    Cancel
                  </button>
                  <button data-testid="delete-record-modal-confirm" className="button is-danger" onClick={() => deleteRecord()}>
                    Delete
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : ''
}
